import { render } from "./campaignCollections.vue?vue&type=template&id=f6d1a138&scoped=true"
import script from "./campaignCollections.vue?vue&type=script&lang=js"
export * from "./campaignCollections.vue?vue&type=script&lang=js"

import "./campaignCollections.vue?vue&type=style&index=0&id=f6d1a138&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d1a138"]])

export default __exports__